import { useEffect, useRef } from 'react'

const useHoverEffect = (className?: string) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const refCopy = wrapperRef.current
    const addHoverEffect = () => {
      if (className) {
        refCopy?.classList.add(className)
      }
    }

    const removeHoverEffect = () => {
      if (className) {
        refCopy?.classList.remove(className)
      }
    }

    if (refCopy) {
      refCopy.addEventListener('mouseover', addHoverEffect)
      refCopy.addEventListener('mouseout', removeHoverEffect)
    }

    return () => {
      if (refCopy) {
        refCopy.removeEventListener('mouseover', addHoverEffect)
        refCopy.removeEventListener('mouseout', removeHoverEffect)
      }
    }
  }, [className])

  return wrapperRef
}

export default useHoverEffect
